import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import { wrapEvent } from '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import { useId } from '@reach/auto-id';
import VisuallyHidden from '../VisuallyHidden/index.esm.js';
import Label from '../Label/index.esm.js';

var Switch = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$id = props.id,
      id = _props$id === void 0 ? "switch-" + useId() : _props$id,
      name = props.name,
      value = props.value,
      defaultChecked = props.defaultChecked,
      checkedProp = props.checked,
      disabled = props.disabled,
      invalid = props.invalid,
      readOnly = props.readOnly,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["id", "name", "value", "defaultChecked", "checked", "disabled", "invalid", "readOnly", "onChange", "onBlur", "onFocus", "aria-label", "aria-labelledby", "children"]);

  var _useState = useState(defaultChecked || false),
      checked = _useState[0],
      setChecked = _useState[1];

  var _useRef = useRef(checkedProp != null),
      isControlled = _useRef.current;

  var internalChecked = isControlled ? checkedProp : checked;
  var wrapperStyleProps = {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'align-middle',
    height: 'h-4',
    width: 'w-8',
    boxSizing: 'box-content',
    backgroundColor: internalChecked ? 'bg-blue-500' : 'bg-gray-300',
    borderWidth: 'border-2',
    borderColor: 'border-transparent',
    borderRadius: 'rounded-full',
    textColor: 'text-white',
    transitionProperty: 'transition',
    transitionDuration: 'duration-200',
    boxShadow: 'focus-within:shadow-outline-blue',
    cursor: 'cursor-pointer'
  };

  if (disabled) {
    wrapperStyleProps.cursor = 'cursor-not-allowed';
  }

  if (disabled) {
    wrapperStyleProps.backgroundColor = internalChecked ? 'bg-gray-500' : 'bg-gray-200';
    wrapperStyleProps.boxShadow = 'focus-within:shadow-outline-gray';
  }

  if (invalid) {
    wrapperStyleProps.backgroundColor = internalChecked ? 'bg-red-500' : 'bg-red-300';
    wrapperStyleProps.boxShadow = 'focus-within:shadow-outline-red';
  }

  var handleStyleProps = {
    position: 'absolute',
    transform: 'transform',
    transitionProperty: 'transition-transform',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: 'duration-200',
    translate: internalChecked ? 'translate-x-full' : undefined,
    height: 'h-4',
    width: 'w-4',
    backgroundColor: 'bg-current',
    borderRadius: 'rounded-full'
  };
  var comp = React__default.createElement(Box, _extends({
    as: "label"
  }, wrapperStyleProps, !children ? rest : {}, {
    dangerouslySetClassName: internalChecked ? 'switch--checked' : undefined,
    backgroundRepeat: "bg-no-repeat"
  }), React__default.createElement(VisuallyHidden, {
    as: "input",
    ref: ref,
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    "aria-invalid": invalid,
    onChange: wrapEvent(onChange, function (event) {
      setChecked(event.target.checked);
    }),
    onBlur: onBlur,
    onFocus: onFocus,
    checked: internalChecked,
    disabled: disabled,
    readOnly: readOnly,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy
  }), React__default.createElement(Box, _extends({}, handleStyleProps)));

  if (!children) {
    return comp;
  }

  return React__default.createElement(Box, _extends({
    display: "flex",
    alignItems: "items-center"
  }, rest), comp, React__default.createElement(Label, {
    htmlFor: id,
    margin: "ml-2",
    textColor: invalid ? 'text-red-500' : undefined
  }, children));
});

if (__DEV__) {
  Switch.displayName = 'Tab';
}

export default Switch;
//# sourceMappingURL=index.esm.js.map
